import React from 'react';

import ActionTileView from '../ActionTile.View';
import {TournamentActionModel} from './TournamentAction.model';

export default React.memo(function TournamentActionView({
  label,
  hint,
  onPress,
}: TournamentActionModel) {
  return (
    <ActionTileView
      testID="v2-action-tournament"
      icon="trophy"
      label={label}
      hint={hint}
      onPress={onPress}
    />
  );
});
